import React from "react";

const EarningHeader = () => {

    return (

        <div className="earning-header">

            <div>

                <h2>Earnings & Commission</h2>

                <p>
                    Monitor revenue, commissions and settlements.
                </p>

            </div>

        </div>

    );

};

export default EarningHeader;